/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lens_MineInputs */

const en_lens_mine = /** @type {(inputs: Lens_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My brands`)
};

/**
* | output |
* | --- |
* | "My brands" |
*
* @param {Lens_MineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const lens_mine = /** @type {((inputs?: Lens_MineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lens_MineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lens_mine(inputs)
});